"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TAB_TYPE_LABEL = exports.TAB_TYPE = exports.LIMIT = exports.CHILD = exports.ROOT = void 0;
exports.ROOT = 'horizontal-tab';
exports.CHILD = 'horizontal-tab/horizontal-tab-pane';
exports.LIMIT = {
    MAX: 8
};
// 激活样式类型
exports.TAB_TYPE = {
    LINE: 0,
    CIRCLE: 1 // 圆形
};
exports.TAB_TYPE_LABEL = {
    [exports.TAB_TYPE.LINE]: '线段',
    [exports.TAB_TYPE.CIRCLE]: '圆形'
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJjb25zdGFudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLElBQUksR0FBRyxnQkFBZ0IsQ0FBQztBQUN4QixRQUFBLEtBQUssR0FBRyxvQ0FBb0MsQ0FBQztBQUU3QyxRQUFBLEtBQUssR0FBRztJQUNqQixHQUFHLEVBQUUsQ0FBQztDQUNULENBQUM7QUFFRixTQUFTO0FBQ0ksUUFBQSxRQUFRLEdBQUc7SUFDcEIsSUFBSSxFQUFFLENBQUM7SUFDUCxNQUFNLEVBQUUsQ0FBQyxDQUFDLEtBQUs7Q0FDbEIsQ0FBQztBQUNXLFFBQUEsY0FBYyxHQUFHO0lBQzFCLENBQUMsZ0JBQVEsQ0FBQyxJQUFJLENBQUMsRUFBRSxJQUFJO0lBQ3JCLENBQUMsZ0JBQVEsQ0FBQyxNQUFNLENBQUMsRUFBRSxJQUFJO0NBQzFCLENBQUMifQ==